import BankLoanConfigStatusFactory from "@/models/factories/BankLoanConfigStatusFactory";
import ProposalFactory from "@/models/factories/ProposalFactory";

const state = {
  proposal: ProposalFactory.create(),
  bankLoanConfigStatus: BankLoanConfigStatusFactory.create(),
};

export default state;
